import { render, staticRenderFns } from "./CategoriesMobile.vue?vue&type=template&id=ac1e3800"
import script from "./CategoriesMobile.vue?vue&type=script&lang=ts"
export * from "./CategoriesMobile.vue?vue&type=script&lang=ts"
import style0 from "../../../assets/smart-carousel/smart-carousel.css?vue&type=style&index=0&prod&v-if=windowWidth%20%3C%3D%20minWindowWidth&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports